"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ArticleCard = function ArticleCardComponent(_ref) {
  var _ref$cardItem = _ref.cardItem,
      cardTitle = _ref$cardItem.card_title,
      cardTitleAlignment = _ref$cardItem.card_title_alignment,
      cardImage = _ref$cardItem.card_image,
      cardBody = _ref$cardItem.card_body,
      dataClient = _ref.dataClient;
  var titleClasses = (0, _classnames["default"])({
    'content-page__article-card-title': true,
    'content-page__article-card-title--center': cardTitleAlignment === 'Center',
    'content-page__article-card-title--right': cardTitleAlignment === 'Right'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__article-card"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "content-page__article-card-image",
    src: cardImage.url,
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("h2", {
    className: titleClasses
  }, dataClient.textToMarkdown(cardTitle)), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__article-card-text",
    content: cardBody
  }));
};

ArticleCard.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  cardItem: _propTypes["default"].shape({
    card_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    card_image: _propTypes["default"].shape({}).isRequired,
    card_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    card_title_alignment: _propTypes["default"].string
  }).isRequired
};
var _default = ArticleCard;
exports["default"] = _default;